var financial_institutions = {
  financial_institutions: { 
    1: {
      id: '1',
      name: 'Royal Bank of Canada',
      txt_id: 'rbc',
      fin: '003'
    },
    2: {
      id: '2',
      name: 'TD Bank',
      txt_id: 'td',
      fin: '004'
    },
    3: {
      id: '3',
      name: 'Bank of Nova Scotia',
      txt_id: 'scotiabank',
      fin: '002'
    },
    4: {
      id: '4',
      name: 'Bank of Montreal',
      txt_id: 'bmo',
      fin: '001'
    },
    5: {
      id: '5',
      name: 'Canadian Imperial Bank of Commerce',
      txt_id: 'cibc',
      fin: '010'
    },
    32: {
      id: '32',
      name: 'Access Credit Union',
      txt_id: 'access',
      fin: null
    },
    6: {
      id: '6',
      name: 'ADS Canadian',
      txt_id: 'ads',
      fin: '343'
    },
    33: {
      id: '33',
      name: 'Affinity Credit Union',
      txt_id: 'affinity',
      fin: null
    },
    7: {
      id: '7',
      name: 'Alterna Bank',
      txt_id: 'alterna',
      fin: '842'
    },
    34: {
      id: '34',
      name: 'Alterna Savings and Credit Union',
      txt_id: 'alterna_credit',
      fin: '842'
    },
    35: {
      id: '35',
      name: 'Assiniboine Credit Union',
      txt_id: 'assiniboine',
      fin: null
    },
    8: {
      id: '8',
      name: 'B2B Bank',
      txt_id: 'b2b',
      fin: '618'
    },
    36: {
      id: '36',
      name: 'BlueShore Financial Credit Union',
      txt_id: 'blueShore',
      fin: null
    },
    9: {
      id: '9',
      name: 'Bridgewater Bank',
      txt_id: 'bridgewater',
      fin: '347'
    },
    10: {
      id: '10',
      name: 'Canadian Tire Bank',
      txt_id: 'canadian_tire',
      fin: '338'
    },
    11: {
      id: '11',
      name: 'Canadian Western Bank',
      txt_id: 'canadian_western',
      fin: '030'
    },
    37: {
      id: '37',
      name: 'Coast Capital Savings',
      txt_id: 'coast_capital',
      fin: '809'
    },
    12: {
      id: '12',
      name: 'Concentra Bank',
      txt_id: 'concentra',
      fin: '853'
    },
    38: {
      id: '38',
      name: 'Conexus Credit Union',
      txt_id: 'conexus',
      fin: null
    },
    39: {
      id: '39',
      name: 'Connect First Credit Union',
      txt_id: 'connect',
      fin: null
    },
    13: {
      id: '13',
      name: 'Continental Bank of Canada',
      txt_id: 'cbc',
      fin: null
    },
    14: {
      id: '14',
      name: 'DirectCash Bank',
      txt_id: 'direct_cash',
      fin: '352'
    },
    15: {
      id: '15',
      name: 'Duo Bank',
      txt_id: 'duo',
      fin: '359'
    },
    16: {
      id: '16',
      name: 'Equitable Bank',
      txt_id: 'equitable',
      fin: '623'
    },
    17: {
      id: '17',
      name: 'Exchange Bank of Canada',
      txt_id: 'exchange',
      fin: '376'
    },
    18: {
      id: '18',
      name: 'First Nations Bank of Canada',
      txt_id: 'first_nations',
      fin: '210'
    },
    40: {
      id: '40',
      name: 'First Ontario Credit Union Limited',
      txt_id: 'first_ontario',
      fin: null
    },
    41: {
      id: '41',
      name: 'First West Credit Union',
      txt_id: 'first_west',
      fin: null
    },
    19: {
      id: '19',
      name: 'General Bank of Canada',
      txt_id: 'general',
      fin: '344'
    },
    20: {
      id: '20',
      name: 'Haventree Bank',
      txt_id: 'haventree',
      fin: null
    },
    21: {
      id: '21',
      name: 'Home Bank',
      txt_id: 'home',
      fin: '361'
    },
    42: {
      id: '42',
      name: 'Innovation Credit Union',
      txt_id: 'innovation',
      fin: null
    },
    22: {
      id: '22',
      name: 'Laurentian Bank',
      txt_id: 'laurentian',
      fin: '039'
    },
    23: {
      id: '23',
      name: 'Manulife Bank of Canada',
      txt_id: 'manulife',
      fin: '540'
    },
    43: {
      id: '43',
      name: 'Meridian Credit Union',
      txt_id: 'meridian',
      fin: '837'
    },
    24: {
      id: '24',
      name: 'Motus Bank',
      txt_id: 'motus',
      fin: '374'
    },
    25: {
      id: '25',
      name: 'Rogers Bank',
      txt_id: 'rogers',
      fin: null
    },
    44: {
      id: '44',
      name: 'Servus Credit Union',
      txt_id: 'servus',
      fin: '899'
    },
    45: {
      id: '45',
      name: 'Steinbach Credit Union',
      txt_id: 'steinbach',
      fin: '879'
    },
    26: {
      id: '26',
      name: 'Street Capital Bank of Canada',
      txt_id: 'scbc',
      fin: null
    },
    27: {
      id: '27',
      name: 'Tangerine Bank',
      txt_id: 'tangerine',
      fin: '614'
    },
    46: {
      id: '46',
      name: 'UNI Financial Cooperation',
      txt_id: 'uni',
      fin: null
    },
    28: {
      id: '28',
      name: 'Vancity',
      txt_id: 'vancity',
      fin: '809'
    },
    29: {
      id: '29',
      name: 'VersaBank',
      txt_id: 'versa_bank',
      fin: '334'
    },
    30: {
      id: '30',
      name: 'Wealth',
      txt_id: 'wealth',
      fin: '370'
    },
    31: {
      id: '31',
      name: 'Zag Bank',
      txt_id: 'zag',
      fin: '342'
    }
  }
}

module.exports = financial_institutions
